import api from 'apis/api';
import filterApiErr from 'apis/filterApiError';
import { EditableUserInfo, User } from 'models/user/User';
import ERR_MSG from 'utils/errorMessage';

export const getUser = async (userId: string) => {
  try {
    const resp = await api.get(`/api/v1/users/${userId}/profile`);
    const data = resp.data as User;
    return Promise.resolve(data);
  } catch (_err: any) {
    let errMsg = '';

    const err = filterApiErr(_err);
    if (err) {
      const errMsgFromServer = err.response.data.message;
      if (errMsgFromServer) errMsg = errMsgFromServer;
      else errMsg = `${ERR_MSG.UNKNOWN} ${ERR_MSG.REPORT}`;
    }

    return Promise.reject(errMsg);
  }
};

export const patchUser = async (userId: string, newUserInfo: Partial<EditableUserInfo>) => {
  try {
    const resp = await api.patch(`/api/v1/users/${userId}`, newUserInfo);
    const data = resp.data as User;
    return Promise.resolve(data);
  } catch (_err: any) {
    let errMsg = '';

    const err = filterApiErr(_err);
    if (err) {
      errMsg = `${ERR_MSG.UNKNOWN} ${ERR_MSG.REPORT}`;
    }

    return Promise.reject(errMsg);
  }
};
